import { BaseQueryParams } from '../../Global.model';
import { MeasurementSystem } from '../../../providers/User/User.model';

export enum CommodityUnit {
  PIECE = 'PIECE',
  PALLET = 'PALLET',
  CASE = 'CASE',
  BUNDLE = 'BUNDLE',
  ROLL = 'ROLL',
  DRUM = 'DRUM',
  BAG = 'BAG',
  CARTON = 'CARTON',
  BOX = 'BOX',
  SKID = 'SKID',
  GALLONS = 'GALLONS',
}

export interface CommodityTableAttributes {
  id: string;
  tenant_id: string;
  name: string;
  quantity: number | null;
  weight: number | null;
  unit: CommodityUnit | null;
  length: number | null;
  width: number | null;
  height: number | null;
  measurement_system: MeasurementSystem | null;
  commodity_id: string | null;
  requires_permit: boolean;
  notes: string | null;
  make: string | null;
  model: string | null;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date | null;
  is_linked?: boolean;
}

export type CommodityCreationAttributes = Omit<CommodityTableAttributes, 'id' | 'created_at' | 'updated_at' | 'deleted_at' | 'tenant_id'>;

export type CommodityUpdateAttributes = Partial<CommodityCreationAttributes>;

export interface SearchCommoditiesFilters {
  search?: string;
  commodityIds?: string[];
  unit?: CommodityUnit;
  requires_permit?: boolean;
}

export interface SearchCommoditiesParams {
  filters?: SearchCommoditiesFilters;
  params?: BaseQueryParams;
}

export type SearchCommoditiesResponseDto = CommodityTableAttributes; 

export type CreateCommoditiesForm = 
  Pick<CommodityTableAttributes, 
    'name' | 
    'quantity' | 
    'weight' | 
    'unit' | 
    'length' | 
    'width' | 
    'height' | 
    'commodity_id' | 
    'requires_permit' | 
    'notes'
  > & {
    id: string;
  };

export interface CommodityTransformedData {
  name: string;
  unit: CommodityUnit | null;
  weight: number | null;
  length_right: string | null;
  length_left: string | null;
  width_right: string | null;
  width_left: string | null;
  height_right: string | null;
  height_left: string | null;
  commodity_id: string | null;
  readable_commodity_id: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  permit: boolean;
  notes: string | null;
  make: string | null;
  model: string | null;
}

export interface CommodityList extends CommodityTransformedData {
  id?: string;
  ui_uid: string;
  quantity: number | null;
  measurement_system: MeasurementSystem | null;
  customer?: string;
  order_id?: string;
  customer_number?: string;
  order_readable_id?: string | number;
  order_commodity_id?: string;
}
